import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import s1 from '../assets/med/s1.jpg';
import s2 from '../assets/med/s2.jpg';
import s3 from '../assets/med/s3.jpg';
import s4 from '../assets/med/s4.jpg';
import s5 from '../assets/med/s5.jpg';
import s6 from '../assets/med/s6.jpg';
import s7 from '../assets/med/s7.jpg';
import s8 from '../assets/med/s8.jpg';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneNews from "./OneNews";


export default function NewsBanner(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  

  if (ready) {
    return (
      <div 
        className="MainBodySection bg-background"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px"
        }}
      >
        
        <div 
          className="container"
          
        >
          
      

          <div className="row">

            <div className="col-md-12">
              <h6
                className="main-section-title"
              >
                News
                <span
                  style={{
                    display: "block",
                    borderBottom: "3px solid var(--secondaryColor)",
                    width: "50px",
                    marginTop: "10px"
                  }}
                >

                </span>
              </h6>
            </div>

            
            {
              (appContext.allNews && appContext.allNews.length > 0) ?
              appContext.allNews.map((item, i) => {
                return (
                  <div key={i} className="col-md-6">
                    <OneNews data={item}/>
                  </div>
                )
              })
              :
              <div className="col-md-12 mb-1 mt-1">
                <h6>Hospium updates will be published here as the platform develops.</h6>
              </div>
            }

            
            
            
          </div>

          
        </div>
          
        
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
